import { container } from 'inversify-props';
import {
	IAuditService, AuditService,
} from '../services/history';

export default () => {
	container.bind<IAuditService>('IAuditService').to(AuditService);
};
